import React from 'react';
import Dialog from 'epn-ui/umd/dist/components/Dialog';
import Button from 'epn-ui/umd/dist/components/Button';
import useI18n from '@i18n';
import { isGlobalDomain } from '@config/globalDomain';
import BaseSanitizer from '@base/BaseSanitizer';

interface IAddPlacementSentModal {
    isOpen: boolean;
    onClose: () => void;
    closeButtonText?: string;
}

const AddPlacementSentModal: React.FC<IAddPlacementSentModal> = ({
    isOpen,
    onClose,
    closeButtonText,
}) => {
    const { t, locale } = useI18n('Offers');

    return (
        <Dialog onCancel={onClose} open={isOpen} size="sm">
            <div className="p-[8px] xs-[16px]">
                <p className="font-bold text-center text-blueGray-800 text-[24px] leading-[35px]">
                    {t('Connection request sent')}
                </p>
                <BaseSanitizer
                    html={t('Track the status of your request in the Placements section', {
                        url: isGlobalDomain ? 'epncpa.pro' : 'epn.bz',
                        locale,
                    })}
                    tag="p"
                    options={{ allowedTags: ['a'] }}
                    className="w-full text-center mt-[8px] text-blueGray-600"
                />

                <div className="flex flex-col w-full gap-[16px] mt-[24px]">
                    <Button type="primary" className="w-full" onClick={onClose}>
                        {closeButtonText || t('Stay in the offer catalog')}
                    </Button>
                    <Button
                        type="default"
                        className="w-full"
                        href={`/${locale}/placements`}
                        target="_blank"
                    >
                        {t('Open placements')}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};

export default AddPlacementSentModal;
